/** @format **/

import React from 'react';

import { Chrome as ClassicChrome } from './classic';

export const Chrome: React.FunctionComponent<{}> = ({ children }) => (
  <ClassicChrome>{children}</ClassicChrome>
);
